import fetcher from 'features/shared/utils/fetcher'

async function postRegisterService(value:object) {
  
  return await fetcher.post('/patient/service/store',value)
}

export default postRegisterService
